"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _constants = require("../Icon/constants");

require("./Label.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** The label is always used on text inputs (textareas) and don’t depend on the placeholder text. */
function Label(_ref) {
  var htmlFor = _ref.htmlFor,
      label = _ref.label,
      helpText = _ref.helpText,
      labelInfobox = _ref.labelInfobox,
      required = _ref.required;
  return /*#__PURE__*/_react.default.createElement("label", {
    className: required ? 'Form-control-label required' : 'Form-control-label',
    htmlFor: htmlFor
  }, /*#__PURE__*/_react.default.createElement("span", null, label), labelInfobox && helpText && /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: helpText
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    type: _constants.ICON_TYPE_TOOLTIP
  })));
}

Label.propTypes = {
  /** @ignore */
  htmlFor: _propTypes.default.string,

  /** The label text */
  label: _propTypes.default.string,

  /** The text displayed if the label tooltip exist */
  helpText: _propTypes.default.bool,

  /** If there is more information for the text input needed make use an info box */
  labelInfobox: _propTypes.default.bool,

  /** If required field* */
  required: _propTypes.default.bool
};
Label.defaultProps = {
  htmlFor: null,
  label: null,
  helpText: null,
  labelInfobox: false,
  required: false
};
var _default = Label;
exports.default = _default;